// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__mElEu","tab":"Tabs_tab__kE2yZ","active":"Tabs_active__RXc5W"};